import { render, staticRenderFns } from "./ChatHumanHigh.vue?vue&type=template&id=d007290c&scoped=true&"
import script from "./ChatHumanHigh.vue?vue&type=script&lang=js&"
export * from "./ChatHumanHigh.vue?vue&type=script&lang=js&"
import style0 from "./ChatHumanHigh.vue?vue&type=style&index=0&id=d007290c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d007290c",
  null
  
)

export default component.exports